module.exports = __webpack_public_path__ + "static/media/For-You-Inactive.a3438718.svg";